import axios from 'axios';
import { saveAs } from 'file-saver';



// import http from "./http";
// let base = 'http://192.168.2.102:5000/api';
// let base  = 'http://172.20.10.3:5000/api'
//  let base = 'http://127.0.0.1:8000';
// let base = 'http://10.32.92.248:5000/api';
// let base = 'http://10.32.93.117:5000/api';
// let base = 'http://10.37.129.2:5000/api';
let base = 'https://re.beyondttyy.top/re'; //

export const requestLogin = params => {
    return axios({
        method: 'POST',
        url: `${base}/system_login`,
        // auth: params
        //发送格式为json
        data:JSON.stringify(params),
        headers:
            {
                'Content-Type': 'application/json'
            }

    })
    .then(res => res.data);
};

export const GetActionListPage = params => {
    return axios({
        method: 'POST',
        url: `${base}/api/getAction/`,
        // auth: params
        //发送格式为json
        data:JSON.stringify(params),
    })
        .then(res => res.data);
};




export const GetUserListPage = params => {
    return axios({
        method: 'POST',
        url: `${base}/get_user_list`,
        // auth: params
        //发送格式为json
        data:JSON.stringify(params),
    })
        .then(res => res.data);
};

export const GetFileListPage = params => {
    return axios({
        method: 'POST',
        url: `${base}/auth/getFile`,
        // auth: params
        //发送格式为json
        data:JSON.stringify(params),
    })
        .then(res => res.data);
};



export const saveUserInfo = params => {
    return axios({
        method: 'POST',
        url: `${base}/saveUser`,
        // auth: params
        //发送格式为json
        data:JSON.stringify(params),

    })
        .then(res => res.data);
};

export const unlockUser = params => {
    return axios({
        method: 'POST',
        url: `${base}/unlock_user`,
        data: JSON.stringify(params),
    })
        .then(res => res.data);
};


export const saveFileInfo = params => {
    return axios({
        method: 'POST',
        url: `${base}/auth/uploadFile`,
        // auth: params
        //发送格式为json
        data:JSON.stringify(params),

    })
        .then(res => res.data);
};


export const getUserSn = params => {
    return axios({
        method: 'POST',
        url: `${base}/get_user_sn`,
        // auth: params
        //发送格式为json
        data:JSON.stringify(params),

    })
        .then(res => res.data);
};


export const setpwd = params => {
    return axios({
        method: 'POST',
        url: `${base}/setpwd`,

        data:JSON.stringify(params),

    })
        .then(res => res.data);
};












export const getOrderInfoListPage = params => {
    return axios({
        method: 'POST',
        url: `${base}/order/listpage`,
        // auth: params
        //发送格式为json
        data:JSON.stringify(params),

    })
        .then(res => res.data);
};
export const getQuotationInfoPage = params => {
    return axios({
        method: 'POST',
        url: `${base}/getQuotationInfo`,
        // auth: params
        //发送格式为json
        data:JSON.stringify(params),

    })
        .then(res => res.data);
};



export const getSalesmanInfoPage = params => {
    return axios({
        method: 'POST',
        url: `${base}/getSalesmanInfo`,
        // auth: params
        //发送格式为json
        data:JSON.stringify(params),

    })
        .then(res => res.data);
};


export const SendingReceivingInfoPage = params => {
    return axios({
        method: 'POST',
        url: `${base}/SendingReceivingInfo`,
        // auth: params
        //发送格式为json
        data:JSON.stringify(params),

    })
        .then(res => res.data);
};
export const getCustomersInfoPage = params => {
    return axios({
        method: 'POST',
        url: `${base}/getCustomersInfo`,
        // auth: params
        //发送格式为json
        data:JSON.stringify(params),

    })
        .then(res => res.data);
};



export const saveSalesmanInfo = params => {
    return axios({
        method: 'POST',
        url: `${base}/saveSalesmanInfo`,
        // auth: params
        //发送格式为json
        data:JSON.stringify(params),

    })
        .then(res => res.data);
};
export const sendSaveSendingReceiving = params => {
    return axios({
        method: 'POST',
        url: `${base}/saveSendingReceiving`,
        // auth: params
        //发送格式为json
        data:JSON.stringify(params),

    })
        .then(res => res.data);
};
export const sendSaveCustomersInfo = params => {
    return axios({
        method: 'POST',
        url: `${base}/sendSaveCustomersInfo`,
        // auth: params
        //发送格式为json
        data:JSON.stringify(params),

    })
        .then(res => res.data);
};

export const checkCustomer = params => {
    return axios({
        method: 'POST',
        url: `${base}/checkCustomer`,
        // auth: params
        //发送格式为json
        data:JSON.stringify(params),

    })
        .then(res => res.data);
};


export const getBarcodeList = params => {
    return axios({
        method: 'POST',
        url: `${base}/getBarcode`,
        // auth: params
        //发送格式为json
        data:JSON.stringify(params),

    })
        .then(res => res.data);
};


export const getTodayOrderSnCode = params => {
    return axios({
        method: 'POST',
        url: `${base}/getTodayOrderSn`,
        // auth: params
        //发送格式为json
        data:JSON.stringify(params),

    }).then(res => res.data);

};

export const getSenderSelectData = params => {
    return axios({
        method: 'POST',
        url: `${base}/getSenderSelectData`,
        // auth: params
        //发送格式为json
        data:JSON.stringify(params),

    }).then(res => res.data);

};




export const getSalesmanSn = params => {
    return axios({
        method: 'POST',
        url: `${base}/getSalesmanSn`,
        // auth: params
        //发送格式为json
        data:JSON.stringify(params),

    }).then(res => res.data);

    console.log('getTodayOrderSn2')
};
export const getSendingReceivingSn = params => {
    return axios({
        method: 'POST',
        url: `${base}/getSendingReceivingSn`,
        // auth: params
        //发送格式为json
        data:JSON.stringify(params),

    }).then(res => res.data);

    console.log('getTodayOrderSn2')
};
export const getCustomersInfoSn = params => {
    return axios({
        method: 'POST',
        url: `${base}/getCustomersInfoSn`,
        // auth: params
        //发送格式为json
        data:JSON.stringify(params),

    }).then(res => res.data);

    console.log('getTodayOrderSn2')
};


export const getOrderRouteList = params => {
    return axios({
        method: 'POST',
        url: `${base}/orderRoute`,
        // auth: params
        //发送格式为json
        data:JSON.stringify(params),

    })
        .then(res => res.data);
};

export const getUserListExcelEx = params => {
    return axios({
        method: 'POST',
        url: `${base}/api/usersListExcel/`,
        // auth: para
        //发送格式为json
        data:JSON.stringify(params),
        headers:
            {
                'responseType':"arraybuffer",

            },
        responseType:'blob'


    })
        .then((res) => {
            const link = document.createElement('a')
            // let blob = new Blob([res.data], {type: 'application/vnd.ms-excel;charset=utf-8'});
            // let blob = new Blob([res.data], {type: 'application/vnd.ms-excel;charset=utf-8'});
            let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            link.style.display = 'none'
            link.href = URL.createObjectURL(blob);
            link.setAttribute('download', '用户列表.xls')
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)

        }).catch(error => {
            this.$Notice.error({
                title: '错误',
                desc: '网络连接错误'
            })
            console.log(error)
        })
};




export const updateOrder = params => {
    return axios({
        method: 'POST',
        url: `${base}/save_order`,
        // auth: params
        //发送格式为json
        data:JSON.stringify(params),

    })
        .then(res => res.data);
};

//对帐
export const updateOrderReconciliation = params => {
    return axios({
        method: 'POST',
        url: `${base}/save_order`,
        // auth: params
        //发送格式为json
        data:JSON.stringify(params),

    })
        .then(res => res.data);
};


export const sendSaveQuotationInfo = params => {
    return axios({
        method: 'POST',
        url: `${base}/sendSaveQuotationInfo`,
        // auth: params
        //发送格式为json
        data:JSON.stringify(params),

    })
        .then(res => res.data);
};



export const getAllType = params => {
    return axios({
        method: 'POST',
        url: `${base}/api/getAllType/`,
        // auth: params
        //发送格式为json
        data:JSON.stringify(params),

    })
        .then(res => res.data);
};
export const getSalesmanListInfo = params => {
    return axios({
        method: 'POST',
        url: `${base}/getSalesmanList`,
        // auth: params
        //发送格式为json
        data:JSON.stringify(params),

    })
        .then(res => res.data);
};
export const getCustomersListInfo = params => {
    return axios({
        method: 'POST',
        url: `${base}/getCustomersList`,
        // auth: params
        //发送格式为json
        data:JSON.stringify(params),

    })
        .then(res => res.data);
};



// 文件上传
export function postUpload (file) {
    return axios({
        url: `${base}/upload`,
        method: 'post',
        data: file,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

//删除
export const removeOrder = params => {
    return axios({
        method: 'POST',
        url: `${base}/orderDelete`,
        // auth: params
        //发送格式为json
        data:JSON.stringify(params),

    })
        .then(res => res.data);
    // console.log(res)
};


export const removeSalesman = params => {
    return axios({
        method: 'POST',
        url: `${base}/salesmanDelete`,
        // auth: params
        //发送格式为json
        data:JSON.stringify(params),

    })
        .then(res => res.data);
    // console.log(res)
};
export const removeSendingReceiving = params => {
    return axios({
        method: 'POST',
        url: `${base}/sendingReceivingDelete`,
        // auth: params
        //发送格式为json
        data:JSON.stringify(params),

    })
        .then(res => res.data);
    // console.log(res)
};



export const customersInfoDelete = params => {
    return axios({
        method: 'POST',
        url: `${base}/customersInfoDelete`,
        // auth: params
        //发送格式为json
        data:JSON.stringify(params),

    })
        .then(res => res.data);
    // console.log(res)
};






export const getUserListPage = params => {
    return axios.get(`${base}/users/listpage`, { params: params });
};

export const removeUser = params => {
    return axios.get(`${base}/user/remove`, { params: params });
};

export const batchRemoveUser = params => {
    return axios.get(`${base}/user/bathremove`, { params: params });
};

export const getdrawPieChart = () => {
    return axios.get(`${base}/getdrawPieChart`);
};

export const getdrawLineChart = () => {
    return axios.get(`${base}/getdrawLineChart`);
};



// WEBPACK FOOTER //
// ./src/api/api.js